import { useLocation, Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { cn } from '@/lib/utils';

const ROUTE_LABELS: Record<string, string> = {
  '/app': 'Home',
  '/app/alunos': 'Alunos',
  '/app/agenda': 'Agenda',
  '/app/treinos': 'Treinos',
  '/app/financeiro': 'Financeiro',
  '/app/configuracoes': 'Configurações',
  '/app/whatsapp': 'WhatsApp',
  '/app/coach': 'Coach IA',
  '/app/upgrade': 'Premium',
};

export function Breadcrumbs() {
  const { pathname } = useLocation();

  // Only show on deep routes (not /app itself)
  if (pathname === '/app' || !pathname.startsWith('/app/')) return null;

  const segments = pathname.split('/').filter(Boolean); // ['app', 'financeiro']
  const crumbs: { label: string; path: string }[] = [
    { label: 'Home', path: '/app' },
  ];

  let currentPath = '';
  for (const seg of segments) {
    currentPath += `/${seg}`;
    const label = ROUTE_LABELS[currentPath];
    if (label && currentPath !== '/app') {
      crumbs.push({ label, path: currentPath });
    }
  }

  if (crumbs.length <= 1) return null;

  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-1 px-4 pt-3 pb-1 text-xs text-muted-foreground">
      {crumbs.map((crumb, i) => {
        const isLast = i === crumbs.length - 1;
        return (
          <span key={crumb.path} className="flex items-center gap-1">
            {i > 0 && <ChevronRight className="h-3 w-3" />}
            {isLast ? (
              <span className="font-medium text-foreground">{crumb.label}</span>
            ) : (
              <Link
                to={crumb.path}
                className={cn(
                  "hover:text-foreground transition-colors",
                  i === 0 && "flex items-center gap-0.5"
                )}
              >
                {i === 0 && <Home className="h-3 w-3" />}
                {crumb.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
